import { types, flow } from "mobx-state-tree";
import { getEnv } from "../../utils/getEnv";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface TermsInstance extends Instance<typeof Terms> {}
export interface TermsSnapshotIn extends SnapshotIn<typeof Terms> {}
export interface TermsSnapshotOut extends SnapshotOut<typeof Terms> {}

export const Terms = types
  .model("Terms", {
    token: types.identifier,
    alreadyAccepted: types.boolean,
    appointmentId: types.string,
    appointmentTitle: types.string,
    appointmentStartTime: types.string,
    appointmentEndTime: types.string,
    instructions: types.string,
    type: types.union(types.literal(1), types.literal(2)), // terms type (1: general, 2: horse)
  })
  .actions((self) => {
    return {
      // will return BadRequest with the code "4003400" and message "Missing token" if the token is missing
      // will return BadRequest with the code "4003400" and message  "Missing or Invalid number of data values" if the token is invalid,
      // will return BadRequest with the code "4003400" and message  "Data is missing or incorrect" if client, clinic or appointment cant be found.
      // will return BadRequest with the code "4095700" and message  "Appointment has already ended." if the endDate of appointment has passed
      acceptTermsAndConditions: flow<TermsInstance, []>(
        function* acceptTermsAndConditions(): any {
          const env = getEnv(self);

          yield env.tosHttp.post(`v2/termsandconditions`, {
            token: self.token,
            accepted: true,
            type: self.type,
          });

          return { success: true };
        },
      ),
    };
  })
  .views((self) => {
    return {
      get isLoading() {
        return !self.token;
      },
    };
  });
